import type { LineItem } from "~/features/cart/cart/models/CartData";

export class LineItemHelper {
  lineItem: LineItem;
  constructor(lineItem: LineItem) {
    this.lineItem = lineItem;
  }

  isRecommendationProduct() {
    return !!this.lineItem.recoPlace || !!this.lineItem.recoType;
  }

  getProductRecommendation() {
    return this.isRecommendationProduct()
      ? {
          place: this.lineItem.recoPlace ?? "unknown",
          type: this.lineItem.recoType ?? "unknown",
        }
      : undefined;
  }

  getRecommendationType() {
    return this.lineItem.recoType;
  }

  getRecommendationPlace() {
    return this.lineItem.recoPlace;
  }
}

export function wrap(lineItem: LineItem) {
  return new LineItemHelper(lineItem);
}
